import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-24 px-4 bg-green relative overflow-hidden" data-id="element-341">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-342"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-343">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-344">
          <h2 className="text-2xl md:text-3xl text-cream-light mb-4 font-medium" data-id="element-345">
            Presentamos el sistema docente más completo para enseñar
            Industrialización de Alimentos en América Latina.
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-gold mb-6" data-id="element-346">
            Mega Pack Industrialización de Alimentos en el Aula
          </h3>
          <p className="text-lg md:text-xl text-cream mb-12 font-medium" data-id="element-347">
            5 tomos · 4 recursos docentes · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 text-left mb-16" data-id="element-348">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-4 bg-green-dark p-8 rounded-2xl border border-green-light/30" data-id="element-349">
            <div className="flex items-start gap-3" data-id="element-350">
              <X className="text-terracota shrink-0 mt-1" size={20} data-id="element-351" />
              <p className="text-cream-light" data-id="element-352">
                No es teoría copiada de un manual europeo sin contexto.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-353">
              <X className="text-terracota shrink-0 mt-1" size={20} data-id="element-354" />
              <p className="text-cream-light" data-id="element-355">
                No es una colección de archivos sueltos que tenés que ordenar
                vos.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-356">
              <X className="text-terracota shrink-0 mt-1" size={20} data-id="element-357" />
              <p className="text-cream-light" data-id="element-358">
                No es material que tengas que adaptar entero para que funcione
                en tu país.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream p-8 rounded-2xl border border-gold/50 relative overflow-hidden" data-id="element-359">
            <h4 className="text-xl font-bold text-green mb-4" data-id="element-360">
              Es un sistema. Un sistema para que puedas:
            </h4>
            <ul className="space-y-3" data-id="element-361">
              {[{
              title: 'Planificar',
              desc: 'con contenidos organizados de manera lógica y progresiva'
            }, {
              title: 'Enseñar',
              desc: 'con explicaciones técnicas claras y contextualizadas para América Latina'
            }, {
              title: 'Aplicar',
              desc: 'con actividades y prácticas de taller listas para usar'
            }, {
              title: 'Evaluar',
              desc: 'sin construir un solo examen desde cero'
            }, {
              title: 'Desarrollar proyectos',
              desc: 'con guías completas de proyectos productivos reales'
            }].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-362">
                  <Check className="text-terracota shrink-0 mt-1" size={18} data-id="element-363" />
                  <span className="text-ink text-sm" data-id="element-364">
                    <strong className="text-green" data-id="element-365">{item.title}</strong> —{' '}
                    {item.desc}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-366">
          <p className="text-2xl font-serif font-bold text-cream-light mb-8" data-id="element-367">
            La promesa es simple: menos tiempo buscando.{' '}
            <span className="text-gold" data-id="element-368">Más tiempo enseñando.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}